import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SideNavFeature } from '@tekman/onmat/models';
import { EnvironmentService, UserService } from '@tekman/onmat/service/generic';

@Component({
  selector: 'tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent implements OnInit, OnChanges {
  @Input() features: SideNavFeature[];
  isTeacher: boolean;
  @Input() status: number;
  @Input() isVisibleStatus = false;
  statusStyle = '';
  correctStatus = true;
  public readonly MAX_FEATURES_INLINE = 4;

  get allActivedFeatures(): boolean {
    return this.features.every(feature => feature.active);
  }

  constructor(private readonly userService: UserService, private readonly env: EnvironmentService) {}

  ngOnInit(): void {
    this.isTeacher = this.userService.isTeacher();
    this.features = this.features?.filter(f => f.title !== 'f.characteristics.evaluable');
  }
  ngOnChanges(change: SimpleChanges) {
    if (change['status']) {
      this.correctStatus = change['status'].currentValue !== '3';
      this.statusStyle = 'status-' + change['status'].currentValue;
    }
  }
}
